import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="materials" — dynamically add/remove nested
// MaterialLine fieldsets, the same template-cloning pattern as time-blocks:
// #add clones the blank template with a fresh index, #remove either drops
// the DOM node (a line that was never saved) or marks it _destroy=1 and
// hides it (a persisted line, so Rails still deletes the record on submit).
export default class extends Controller {
  static targets = ["list", "template", "line", "empty"]

  connect() {
    this.updateEmptyState()
  }

  add() {
    const index = new Date().getTime()
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, index)
    this.listTarget.insertAdjacentHTML("beforeend", html)
    this.updateEmptyState()
  }

  remove(event) {
    const line = event.target.closest("[data-materials-target='line']")
    const destroyField = line.querySelector("input[name$='[_destroy]']")
    const idField = line.querySelector("input[name$='[id]']")

    if (idField && idField.value) {
      destroyField.value = "1"
      line.hidden = true
    } else {
      line.remove()
    }

    this.updateEmptyState()
  }

  updateEmptyState() {
    const visible = this.lineTargets.filter((line) => !line.hidden)
    this.emptyTarget.hidden = visible.length > 0
  }
}
